/**
 *  error.conf.js
 */

var errorConf = function($stateProvider) {
    $stateProvider.state('error', {
        url: '/eroare',
        template: '<div></div>',
        controllerAs: 'ctrl',
        controller: 'ErrorCtrl',
    });
};

errorConf.$inject = ['$stateProvider'];

export default errorConf;